//api / liftpermission / { loginId } / Lift
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserLiftPermissionService } from 'src/app/user/services/usr-lift-permission.service';

@Injectable({ providedIn: 'root' })
export class LiftPermissionResolver implements Resolve<any> {
  constructor(
    private userLiftPermissionService: UserLiftPermissionService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const liftId = route.params.id;

    return this.userLiftPermissionService.getLoggedUserLiftPermission(liftId);
  }
}
